/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/building_construction'
export default icon
